import React, {useState, useEffect} from "react";
import { Link, useParams } from "react-router-dom";
import Navigation from "../partials/Navigation";
import hviCoverImg from "./../images/hvi-cover-img.jpg";
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import oviQuestions from "../utils/ovi-questions";
import {Helmet} from "react-helmet";
import configVars from "../config";
import { setWithExpiry } from '../common';
// import HviMessages from "../partials/HVI/HviMessages";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import Modal from 'react-bootstrap/Modal';
import OviPersonalSummary from "../partials/HVI/OviPersonalSummary";
import validator from "validator";
import { useTranslation } from "react-i18next";

const OfflineOvi = () => {

	let intVal = [];

	if ( oviQuestions ) {
		oviQuestions.map( ( hviQuestion ) => 
			hviQuestion.type === 'custom' ? intVal.push({value: ''}) : intVal.push({value: 2})
		)
	}

	const [hviVal, setHviVal] = useState(intVal);
	const [currentStep, setCurrentStep] = useState(0);
	const [saving, setSaving] = useState(false);
	const [hviCount, setHviCount] = useState(0);
	const [displayCount, setDisplayCount] = useState(false);
	const [modelShow, setModelShow] = useState(false);
	const [showEmail, setShowEmail] = useState(false);
	const [userEmail, setUserEmail] = useState('');
	const [errorMsg, setErrorMsg] = useState('');
	const { company } = useParams();
	const [recentHvi, setRecentHvi] = useState([]);

	const [translation] = useTranslation("translations");

	const hviLabels = {
		1: '1',
		2: '2',
		3: '3',
		4: '4',
		5: '5',
		6: '6'
	}

	useEffect(() => {

		const queryString = window.location.search;
    	const urlParams = new URLSearchParams(queryString);

		if (urlParams.get("count")) {

			const count = urlParams.get("count");

			if ( count.length > 0 ) {
				setHviCount(count);
				setDisplayCount(true);
			}

		} else {
			setHviCount(0);
			setDisplayCount(false);
		}

	}, []);

	const handleHviUpdate = (val, updatedIndex) => {

		const valInt = parseInt( val, 10 );

		const newHvi = hviVal.map( (obj, index ) => 
			index === updatedIndex ? { ...obj, value: valInt } : obj
		);

		setHviVal( newHvi );

	}

	const handleCompletedPercentage = ( current, total ) => {
		return ((current+1)/total)*100
	}

	const getHviColor = (count) => {
		let color = 'sy-red';

		if ( count > 24 && count < 60 ) {
			color = 'sy-yellow';
		}

		if ( count > 59 ) {
			color = 'dark-green';
		}

		return color;
	}

	const saveUserHvi = async () => {

		if ( !userEmail.toString().trim().length || !validator.isEmail(userEmail) ) {
			setErrorMsg(translation("enter_valid_email"));

			return;
		
		}  else {
			setErrorMsg('');
		}

		setSaving( true );

		const response = await fetch(
			`${configVars.apiUrl}sustainchange/v1/saveofflineuserhvi/?email=${userEmail}&hvidata=${JSON.stringify(hviVal)}&company=${company}&type=ovi`,
			{
				method: "GET",
				headers: {
					Authorization: `Basic ${configVars.auth}`,
				},
			}
		);
		
		const hviResponse = await response.json();

		if ( hviResponse ) {
			
			if ( hviResponse.success === true ) {

				if ( hviResponse.data.recent_hvi ) {

					setRecentHvi( [ hviResponse.data.recent_hvi ] );
					
					setWithExpiry( `sy_recent_ovi`, [ hviResponse.data.recent_hvi ] );

					setHviCount( hviResponse.data.recent_hvi.ovi_count );

					setDisplayCount(true);
					setModelShow(false);

				}

			} else {

				setErrorMsg( hviResponse.message );

			}



		}

		setSaving( false );

	}

	const showResultsOnClose = () => {

		if ( currentStep > 11 ) {

			let totalHvi = 0;

			hviVal.map( (hviItem, index) => {
				if ( index < 12 ) {
					totalHvi = totalHvi + hviItem.value;
				}

				return hviItem;
			});

			setHviCount( totalHvi );
			setDisplayCount(true);

			let today = new Date().toISOString().slice( 0, 10 );

			const newHvi = [
				{
					'data': hviVal,
					'date': today,
					'ovi_count': totalHvi,
				}
			];

			setWithExpiry( `sy_recent_ovi`, newHvi );

			setRecentHvi( newHvi );
		}

	}

	return (
		<div className="main-wrapper">
			<Helmet>
				<title>Organisation Well function Index</title>
				<meta name="description" content="" />
			</Helmet>
			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav title="Välkommen" />
				
				<div className="pt-5 pt-lg-0 page-content-inner">
					<div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px',backgroundImage: `url(${hviCoverImg})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '300px'}}>
						<div className="position-absolute w-100 h-100 top-0 left-0 dark-overlay d-flex justify-content-center align-items-center">
							<h1 className="text-white display-1 text-center text-shadow">Organisation Well function Index</h1>
						</div>
					</div>

						<div className="px-4" style={{maxWidth: '1400px'}}>
							<div className="hvi-wrap mt-5">

								{ displayCount &&
									<>
										<div className="display-count-wrap d-flex align-items-center">
											<h3 className="h1 fw-bold me-2">Ditt Organisation Well function Index är:</h3>
											<span className={`hvi-count text-white text-center h2 mb-0 py-3 bg-${getHviColor(hviCount)}`} style={{width: '150px'}}>{hviCount}</span>
										</div>
										{/* <div className="mt-5">
											<HviMessages count={hviCount} color={getHviColor(hviCount)} />
											
										</div> */}

										<OviPersonalSummary isNew={false} userHvi={recentHvi} />

										<div className="mt-5 mb-6">
											<Link to={`/${company}/ovi/`} className="btn btn-halite-blue rounded-pill btn-lg px-5" onClick={ () => {setHviCount(0);setDisplayCount(false);setShowEmail(false)}}>
												<i className="fa fa-life-ring" aria-hidden="true"></i>
												<span className="ms-3">Gör testet här</span>
											</Link>
										</div>
									</>
								}

								{ oviQuestions && !displayCount &&
									<>
										<div className="hvi-content mb-5">

											<div className="row">
												<div className="col-12 col-lg-9">
                                                <div className="mb-4">
														<h4 className="fw-bold mb-3">Med Organisation Well function Index kan du se hur välfungerande du tycker att organisationen är i relation till dig och ditt arbete.</h4>
														<p>Som arbetsgrupp får ni ett teamresultat att diskutera och utvecklas utifrån. Därefter kan du och ni följa er utveckling över tid - mot en alltmer välfungerande organisation.</p>
													</div>

													<div className="mb-4">
														<p>Med tolv frågor som tar cirka fem minuter att besvara får du en indikation på hur välfungerande du tycker att organisationen är i relation till dig och ditt arbete. Frågorna är framtagna utifrån vad forskning och praktiska erfarenheter påvisat är viktiga kriterier för en välfungerande organisation. Dessa är:</p>
														<ul className="mt-3">
															<li>att medarbetaren har god överblick, ser sin och den egna arbetsgruppens roll i hela arbetsprocessen</li>
															<li>att medarbetaren själv har kontroll över sina arbetsuppgifter och full empowerment, det vill säga har kompetens att utföra sina uppgifter samt de resurser och det mandat som krävs</li>
															<li>att relationerna på arbetsplatsen är goda och trygga</li>
														</ul>
													</div>

													<div className="mb-4">
														<p>Indexet kan vara mellan 12-72 där indexet indikerar hur organisationen fungerar i relation till dig och dina arbetsuppgifter. Teamets resultatet ger en indikation på hur ni som grupp upplever organisationen.</p>
													</div>

													<div className="mb-4">
														<p><span className="bg-sy-red px-2 py-1 me-1 text-white rounded-2">Rött (12-24)</span>: Det kan handla om något tillfälligt, t ex en kris. Om det inte är en tillfällig situation är rött en allvarlig indikation på att organisationen inte är välfungerande ur ditt perspektiv eller om teamresultatet är rött ur hela gruppens perspektiv.</p>
														<p><span className="bg-sy-yellow px-2 py-1 me-1 text-white rounded-2">Gul (25-59)</span>: Här är det intressant att se vad det är som skaver i organisationen, finns det oklarheter som behöver redas ut och hur kan era relationer utvecklas?</p>
														<p><span className="bg-dark-green px-2 py-1 me-1 text-white rounded-2">Grön (60–72)</span>: Du arbetar på arbetsplats om som passar dig mycket väl och har gruppen ett högt index tycker det på att du, och ni, arbetar i en välfungerande organisation.</p>
														<p>Du kan känna dig trygg med att göra testet för dina svar behandlas helt konfidentiellt!</p>
													</div>

													<div className="mb-4">
														<button type="button" className="btn btn-halite-blue rounded-pill btn-lg px-5" onClick={()=> setModelShow(true)}>
															<i className="fa fa-life-ring" aria-hidden="true"></i>
															<span className="ms-3">Starta testet</span>
														</button>
													</div>

													<Modal
														show={modelShow}
														onHide={() => {setModelShow(false); showResultsOnClose();}}
														backdrop="static"
														keyboard={false}
														centered
														size="lg"
														className="hvi-model-wrap"
													>
														<Modal.Header closeButton>
															<Modal.Title>
																{ showEmail &&
																	<span>Nu är det bara ett steg kvar</span>
																}
															</Modal.Title>
														</Modal.Header>
														<Modal.Body className="hvi-model">

															{ !showEmail &&
																<div className="toast show mb-5" role="alert" aria-live="assertive" aria-atomic="true">
																	<div className="toast-header">
																		<strong className="me-auto">Organisation Well function Index (OWI)</strong>
																		<small className="text-muted">{currentStep+1}/{oviQuestions.length}</small>
																	</div>
																	<div className="progress rounded-0" style={{height: '7px'}}>
																		<div className="progress-bar progress-bar-striped progress-bar-animated bg-sy-green rounded-0" role="progressbar" aria-valuenow={handleCompletedPercentage(currentStep, oviQuestions.length)} aria-valuemin="0" aria-valuemax="100" style={{width: `${handleCompletedPercentage(currentStep, oviQuestions.length)}%`}}></div>
																	</div>
																	<div className="toast-body">
																		<div className="hvi-single pb-4 mt-2">
																			<label >
																				<span className="fw-bold pe-2">{currentStep+1})</span>
																				<span>{oviQuestions[currentStep].title}</span>
																			</label>
																			{oviQuestions[currentStep].hints &&
																				<>
																					{oviQuestions[currentStep].hints.map( (hint, index) => {
																						return (
																							<div className="form-text ps-2" key={index}>{hint}</div>
																						)
																					})}
																					
																				</>
											
																			}
																			{oviQuestions[currentStep].type === 'numbers' &&
																				<Slider
																					value={hviVal[currentStep].value}
																					onChange={(value) => handleHviUpdate(value, currentStep)}
																					min={1}
																					max={6}
																					labels={hviLabels}
																				/>
																			}

																			{oviQuestions[currentStep].type === 'custom' && oviQuestions[currentStep].choices?.length > 0 &&
																				<div className="hvi-choices-wrap mt-3">
																					{ oviQuestions[currentStep].choices.map( (choice, index) => {
																						return (
																							<div className={`form-check ${oviQuestions[currentStep].display === 'inline' ? 'form-check-inline' : '' }`} key={index}>
																								<input 
																									className="form-check-input"
																									type="radio"
																									id={`${oviQuestions[currentStep].name}_${index}`} 
																									name={oviQuestions[currentStep].name} 
																									value={index}
																									checked={ hviVal[currentStep].value === index }
																									onChange={ (event) => { handleHviUpdate(event.target.value, currentStep) } }
																								/>
																								<label className="form-check-label" htmlFor={`${oviQuestions[currentStep].name}_${index}`}>{choice}</label>
																							</div>
																						)
																					}) }
																				</div>
																			}
																		</div>
																		<div className="mt-3 pt-3 border-top d-inline-block w-100">
																			{currentStep > 0 &&
																				<button type="button" className="btn btn-primary btn-sm text-white pe-4 ps-3" onClick={() => setCurrentStep(currentStep-1)}>
																					<i className="fa fa-angle-left" aria-hidden="true"></i>
																					<span className="ps-3">Tillbaka</span>
																				</button>
																			}
																			{ (currentStep+1) < oviQuestions.length &&
																				<button type="button" className="btn btn-primary btn-sm float-end text-white ps-4 pe-3" onClick={() => setCurrentStep(currentStep+1)}>
																					<span className="pe-3">Nästa</span>
																					<i className="fa fa-angle-right" aria-hidden="true"></i>
																				</button>
																			}
																			{ (currentStep+1) === oviQuestions.length &&
																				<button type="button" className="btn btn-sea-green btn-sm float-end text-white px-3" onClick={ () => setShowEmail(true) }>
																					<span>Räkna ut ditt OWI</span>
																				</button>
																			}
															
																		</div>
																	</div>
																</div>
															}

															{showEmail &&
																<div className="save-offline-wrap pb-3" >
																	{ errorMsg.length > 0 &&
																		<div className="row">
																			<div className="col-12">
																				<p className="text-sy-red">{errorMsg}</p>
																			</div>
																		</div>
																	}
																	<div className="row">
																		<div className="col-12 mb-2">
																			<p>För att vi ska kunna registrera ditt resultat behöver du ange din e-post. Resultatet kommer presenteras helt avkodat och anonymt. Din e-post kommer inte användas i marknadsföringssyfte.</p>
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-12 col-lg-8">
																			<input type="email" className="form-control" placeholder="Din mailadress" value={userEmail} onChange={ (e) => setUserEmail(e.target.value) } />
																		</div>
																		<div className="col-12 col-lg-4">
																			<button type="button" className="btn btn-sea-green btn-sm text-white px-3 py-2" onClick={() => saveUserHvi()}>
																				<span>Spara</span>
																				{saving &&
																					<div className="spinner-border text-light spinner-border-sm ms-2" role="status" >
																						<span className="visually-hidden">Loading...</span>
																					</div>
																				}
																			</button>
																		</div>
																	</div>
																</div>
															}

														</Modal.Body>
													</Modal>

													

												</div>
											</div>

											{/* <div className="mb-4 mt-4 text-center">
												<h3 className="fw-bold">Hur är testet framtaget?</h3>
												<p>Frågorna är formulerade utifrån utmaningar i vår samtid – stress, sömn, återhämtning, gränsen mellan arbete och fritid – plus två klassiska modeller, KASAM samt Karasek och Theorells krav-kontroll-stöd-modell.</p>
											</div> */}

											
										</div>
										
									</>
								}
							</div>
						</div>
				</div>

			</div>
		</div>
	);
};

export default OfflineOvi;
